import { useRoutes } from "react-router";
import { RootRoute } from "./RootRoute";
import { MemberRoute } from "./MemberRoute";
import { PreTransactionRoute } from "./PreTransactionRoute";
import { DefaultRoute } from "./DefaultRoute";
import { PromotionRoute } from "./PromotionRoute";
import { AffiliatePromotionRoute } from "./AffiliatePromotion";
import { RefundPromotionRoute } from "./RefundPromotionRoute";
import { MarketingRoute } from "./MarketingRoute";
import { ReconcileRoute } from "./ReconcileRoute";
import { AgentManagementRoute } from "./AgentManagementRoute";
import { EmployeeRoute } from "./EmployeeRoute";
import { AnnoucementRoute } from "./AnnouncementRoute";
import { ReportRoute } from "./ReportRoute";
import { SettingRoute } from "./SettingRoute";
import { WebsiteRoute } from "./WebsiteRoute";
import { DistribustorRoute } from "./DistribustorRoute";
import { CreditTrancsactionRoute } from "./CreditTrancsactionRoute";
import { DashboardRoute } from "./DashboardRoute";
import { BetReportRoute } from "./BetReportRoute";
import { PaymentGatewayRoute } from "./PaymentGatewayRoute";
import { PaymentAutoRoute } from "./PaymentAutoRoute";
import { OtpRoute } from "./OtpRoute";
import { AcitiviyLogsRoute } from "./ActivityLogs";
import { SellerRoute } from "./SellerRoute";
import { NotificationRoute } from "./NotificationRoute";
import { NotificationGroupRoute } from "./NotificationGroupRoute";
import { AuthContextProvider } from "../contexts/AuthContext";
import { SelfContextProvider } from "../contexts/SelfContext";

export default function Router() {
  return useRoutes([
    RootRoute(),
    OtpRoute(),
    DefaultRoute(),
    DashboardRoute(),
    MemberRoute(),
    SellerRoute(),

    PreTransactionRoute(),
    ReconcileRoute(),

    PromotionRoute(),
    RefundPromotionRoute(),
    AffiliatePromotionRoute(),
    MarketingRoute(),

    AgentManagementRoute(),
    EmployeeRoute(),
    AnnoucementRoute(),

    ReportRoute(),
    CreditTrancsactionRoute(),
    BetReportRoute(),

    MarketingRoute(),
    SettingRoute(),
    PaymentGatewayRoute(),
    PaymentAutoRoute(),
    WebsiteRoute(),
    DistribustorRoute(),

    NotificationRoute(),
    NotificationGroupRoute(),

    AcitiviyLogsRoute(),
  ]);
}

export const RouterHOC = () => {
  return (
    <AuthContextProvider>
      {/* <SelfContextProvider> */}
      <Router />
      {/* </SelfContextProvider> */}
    </AuthContextProvider>
  );
};
